import React from 'react';
import { onToast, ToastPayload } from '../lib/toast';

type T = Required<ToastPayload>;

export default function Toaster() {
  const [items, setItems] = React.useState<T[]>([]);

  React.useEffect(() => {
    return onToast((t) => {
      setItems((cur) => [...cur, t]);
      const timer = setTimeout(() => {
        setItems((cur) => cur.filter((x) => x.id !== t.id));
      }, t.duration);
      return () => clearTimeout(timer);
    });
  }, []);

  const color = (v: T['variant']) =>
    v === 'success' ? 'border-green-600 bg-green-50'
    : v === 'error' ? 'border-red-600 bg-red-50'
    : v === 'warning' ? 'border-yellow-600 bg-yellow-50'
    : 'border-blue-600 bg-blue-50';

  return (
    <div className="fixed right-4 bottom-4 z-50 space-y-2 w-[320px] max-w-[90vw]">
      {items.map(t => (
        <div
          key={t.id}
          className={`border rounded-xl shadow p-3 animate-in fade-in slide-in-from-bottom-2 ${color(t.variant)}`}
          role="status"
          data-testid="toast"
        >
          <div className="flex items-start gap-2">
            <div className="font-medium">{t.title}</div>
            <button
              className="ml-auto text-xs text-gray-600 hover:text-black"
              onClick={() => setItems(cur => cur.filter(x => x.id !== t.id))}
              aria-label="Close"
            >✕</button>
          </div>
          {t.description ? <div className="text-xs text-gray-700 mt-1 whitespace-pre-wrap">{t.description}</div> : null}
        </div>
      ))}
    </div>
  );
}


